export default "__VITE_ASSET__o_y5yXQq__"